export enum SubscriptionOptions {
  USYearly = "us-yearly",
  USMonthly = "us-monthly",
  USLifetime = "us-lifetime",
  CAYearly = "ca-yearly",
  CAMonthly = "ca-monthly",
  CALifetime = "ca-lifetime",
}
